import React, { Component } from 'react';
import emptyAddressImg from '../assets/empty-address.png';
import emptyOrderImg from '../assets/empty-order.png';
import emptyCartImg from '../assets/empty-shopcart.png';
import { RightOutlined } from '@ant-design/icons';

class CpEmpty extends Component {
  constructor(props) {
    super(props);
    this.statusConfig = {
      "shopCart": {
        img: emptyCartImg,
        title: '购物车空空的哦～，去看看心仪的商品吧 ～',
        button: '去购物',
        handle: () => { this.toHome(); }
      },
      "planList": {
        img: emptyOrderImg,
        title: '当前暂无商品，快去添加吧!',
        button: '去添加',
        handle: () => { this.toHome(); }
      },
      "enquiryCart": {
        img: emptyOrderImg,
        title: '当前暂无商品，快去添加吧！',
        button: '发布商品询价',
        handle: () => { props.action(); }
      },
      "enquiryList": {
        img: emptyOrderImg,
        title: '询价单空空的哦～，去看看心仪的商品吧 ～',
        button: '去发布商品询价',
        handle: () => { props.action(); }
      },
      "order": {
        img: emptyOrderImg,
        title: '采购单空空的哦～，去看看心仪的商品吧 ～',
        button: '去购物',
        handle: () => { this.toHome(); }
      },
      "returnOrder": {
        img: emptyOrderImg,
        title: '退货单空空的哦～，去看看心仪的商品吧 ～',
        button: '去购物',
        handle: () => { this.toHome(); }
      },
      "planOrder": {
        img: emptyOrderImg,
        title: '计划单空空的哦～，去看看心仪的商品吧 ～',
        button: '去购物',
        handle: () => { this.toHome(); }
      },
      "proposalOrder": {
        img: emptyOrderImg,
        title: '订货单空空的哦～，去看看心仪的商品吧 ～',
        button: '去购物',
        handle: () => { this.toProposal(); }
      },
      "purchaseOrder": {
        img: emptyOrderImg,
        title: '订货清单空空的哦～，去看看心仪的商品吧 ～',
        button: '去购物',
        handle: () => { this.toProposal(); }
      },
      "cpmPurchaseCart": {
        img: emptyOrderImg,
        title: '采购清单空空的哦～',
        // button: '去购物',
        // handle: () => { this.toProposal(); }
      },
      "qualityStandard": {
        img: emptyOrderImg,
        title: '请增加商品质检标准',
        // button: '去购物',
        // handle: () => { this.toProposal(); }
      },
      "qualityGradient": {
        img: emptyOrderImg,
        title: '请增加商品抽检梯度',
        // button: '去购物',
        // handle: () => { this.toProposal(); }
      },
      "qualityTask": {
        img: emptyOrderImg,
        title: '暂无质检记录',
        // button: '去购物',
        // handle: () => { this.toProposal(); }
      },
      "purchaseOrderDetail": {
        img: emptyOrderImg,
        title: '请添加商品 ～',
        button: '',
        handle: () => { }
      },
      "quotationSearch": {
        img: emptyOrderImg,
        title: '预估报价空空的哦～，去看看心仪的商品吧 ～',
        button: '去购物',
        handle: () => { this.toHome(); }
      },
      "address": {
        img: emptyAddressImg,
        title: '收货地址空空的哦～，去添加收货地址吧 ～',
        button: '添加地址',
        handle: () => { this.addAddress(); }
      },
      "planOrderAddress": {
        img: emptyAddressImg,
        title: '您还没有收货地址，请先添加收货地址再进行提报',
        button: '去添加收货地址',
        handle: () => { this.goAddress(); }
      },
    };
  }

  toHome = () => this.props.history.push('/basic/home');
  toProposal = () => this.props.history.push('/basic/user/proposal');
  addAddress = () => this.props.onClicked();
  goAddress = () => this.props.history.push('/basic/user/address');
  render() {
    const { status } = this.props;
    const value = this.statusConfig[status];

    return (
      <div className="cp-empty">
        <img className="cp-empty-icon" src={value?.img} alt="" />
        <div className="cp-empty-text">
          <span>{value?.title}</span>
          {value?.button ? <a onClick={value?.handle}>{value?.button} <RightOutlined className="right-icon" /></a> : null}
        </div>
      </div>
    );
  }
}

export default CpEmpty;